import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const proceduceService = {
  get: async (search, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDURE.GET}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_category: async (categoryId, page = 1, limit = 10, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDURE.GET_BY_CATEGORY}/${categoryId}?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (proceduce_id, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDURE.GET_BY_ID}/${proceduce_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
